<template>
	<b-input-group class="float-icon p-2 bg-body input-group-round input-group-dark">
		<b-icon icon="search" />
		<b-form-input
			v-model="modifiedValue"
			:value="value"
			:placeholder="$t('search')"
			type="search"
			class="form-control-round"
			size="sm"
			:debounce="debounce"
			v-bind="{ name, id }"
		/>
	</b-input-group>
</template>

<script>
export default {
	props: {
		/**
		 * Necessary for v-model to work with this component.
		 */
		value: {
			type: String,
			required: true,
		},
		/**
		 * The "name" attribute of the input element.
		 */
		name: {
			type: String,
			default: null,
		},
		/**
		 * The "id" attribute of the input element.
		 */
		id: {
			type: String,
			default: null,
		},
		debounce: {
			type: String,
			default: '0',
		},
	},
	data() {
		return {
			modifiedValue: null,
		};
	},
	watch: {
		modifiedValue: function valueChanged(newVal, oldVal) {
			if (newVal !== oldVal) this.$emit('input', newVal);
		},
	},
};
</script>
